<template>
  <b-container>
    <div class="mt-4 d-flex justify-content-between">
      <back-arrow :bilan-type="operationBilan.bilanType"
                  :params="{operationId: operationId, currentSection:1, operationBilanId:operationBilanId}"
                  :sub-title-ope="this.operationName"
                  :title="$t('operation.bilan.ChargeFonciere')"
                  route-back="OperationShow"/>

      <card-total-component
        :custom-class="`bilan-${operationBilan.bilanType.toLowerCase()}`"
        :value="prixHT | formatEuro"
        class="ml-auto col-md-2"
        title="operation.totalht"/>

      <card-total-component
        :custom-class="`bilan-${operationBilan.bilanType.toLowerCase()}`"
        :value="totalTVA | formatEuro"
        class="ml-2 col-md-2"
        title="operation.totaltva"/>

      <card-total-component
        :custom-class="`bilan-${operationBilan.bilanType.toLowerCase()}`"
        :value="totalTTC | formatEuro"
        class="ml-2 col-md-2"
        title="operation.totalttc"/>

    </div>

    <div class="row justify-content-between mt-3 mb-4">
      <div class="col-md-12">
        <div class="white-card mr-0 p-3">
          <div class="level-two-title main-red-color bold-text mb-3">
            {{ $t('operation.bilan.ChargeFonciere.FraisAquisition') }}
          </div>
          <b-form v-unsave-detector @submit.stop.prevent="onSubmit">
            <div class="row">
              <div class="col-md-6">
                <b-form-group
                  :invalid-feedback="form.prixAchat.invalidFeedback"
                  :label="$t(`operation.bilan.ChargeFonciere.Prix${operationBilan.isHT ? '.HT' : ''}`)"
                  :state="form.prixAchat.state"
                  class="medium-label mb-4"
                  label-for="price-input">
                  <b-form-input
                    id="price-input"
                    v-model="form.prixAchat.value"
                    v-disable-scroll
                    :state="form.prixAchat.state"
                    maxlength="250"
                    required
                    step="any"
                    type="number">
                  </b-form-input>
                </b-form-group>
              </div>

              <div class="col-md-6">
                <b-form-group
                  :invalid-feedback="form.fraisNotaire.invalidFeedback"
                  :label="$t('operation.bilan.ChargeFonciere.FraisNotaire')"
                  :state="form.fraisNotaire.state"
                  class="medium-label mb-4"
                  label-for="notaire-input">
                  <b-form-input
                    id="notaire-input"
                    v-model="form.fraisNotaire.value"
                    v-disable-scroll
                    :state="form.fraisNotaire.state"
                    maxlength="250"
                    required
                    step="any"
                    type="number">
                  </b-form-input>
                </b-form-group>
              </div>

              <div class="col-md-6">
                <b-form-group
                  :invalid-feedback="form.commissions.invalidFeedback"
                  :label="$t('operation.bilan.ChargeFonciere.Commissions')"
                  :state="form.commissions.state"
                  class="medium-label mb-4"
                  label-for="commissions-input">
                  <b-form-input
                    id="commissions-input"
                    v-model="form.commissions.value"
                    v-disable-scroll
                    :state="form.commissions.state"
                    maxlength="250"
                    step="any"
                    type="number">
                  </b-form-input>
                </b-form-group>
              </div>
            </div>
            <div class="d-flex justify-content-end">
              <b-button type="submit" variant="primary">{{ $t('Save') }}</b-button>
            </div>
          </b-form>
        </div>
      </div>

    </div>
  </b-container>
</template>

<script>

import api from '../../../services/api'
import BackArrow from "../../../components/b122/BackArrow.vue";
import CardTotalComponent from "../../operation/components/CardTotalComponent.vue";
import CardComponent from "../../../components/b122/CardComponent.vue";

export default {
  name: "OperationBilanChargeFonciereEdit",

  components: {
    CardTotalComponent,
    CardComponent,
    BackArrow
  },

  data() {
    return {
      totalTTC: "-",
      totalTVA: "-",
      prixHT: "-",
      operationId: this.$route.params.operationId,
      operationBilanId: this.$route.params.operationBilanId,
      simulationId: this.$route.params.simulationId,
      operationName:null,
      operationBilan: {},
      simulation: {},
      form: {
        prixAchat: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        fraisNotaire: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        commissions: {
          state: null,
          invalidFeedback: null,
          value: null
        }
      },
    }
  },

  emits: ['getOperationBilanId'],

  async mounted() {
    await this.fetchData()
  },

  methods: {
    async fetchData() {
      if (this.operationBilanId) {
        await this.fetchOperationBilan()
        this.setInitialValues()
        this.$emit("getOperationBilanId", this.operationBilanId)
        await this.getTotalOfBilan()
      } else if (this.simulationId) {
        await this.fetchSimulation()
        this.setInitialValues()
      }
    },

    async fetchOperationBilan() {
      await api
        .get(`/operationBilan/${this.operationBilanId}`)
        .then(response => {
          this.operationBilan = response.data
          this.operationName = response.data.tostring
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationShow',
              params: {
                operationId: this.operationId,
                currentSection: 1,
                message: error.response.data.message
              }
            })
          }
        })
    },

    async fetchSimulation() {
      await api
        .get(`/simulation/${this.simulationId}`)
        .then(response => {
          this.simulation = response.data
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'SimulationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    async getTotalOfBilan() {
      await api
        .get(`/operationBilan/getTotalOfBilan/${this.operationId}`)
        .then(response => {
          this.totalTTC = response.data[0].prixTTC
          this.totalTVA = response.data[0].TVA
          this.prixHT = response.data[0].prixHT
        })
    },

    setInitialValues() {
      if (this.operationBilan != null) {
        this.form.prixAchat.value = this.operationBilan.prixAchat
        this.form.fraisNotaire.value = this.operationBilan.fraisNotaire
        this.form.commissions.value = this.operationBilan.commissions
      } else if (this.simulation != null) {
        this.form.prixAchat.value = this.simulation.prixAchat
        this.form.fraisNotaire.value = this.simulation.fraisNotaire
        this.form.commissions.value = this.simulation.value
      }
    },

    onSubmit() {
      let data = new FormData()
      data.append('prixAchat', this.form.prixAchat.value)
      data.append('fraisNotaire', this.form.fraisNotaire.value)
      if (this.form.commissions.value != null) {
        data.append('commissions', this.form.commissions.value)
      }
      data.append('operationId', this.operationId)
      data.append('chargeFonciereDone', true)

      let url = '/operationBilan/'
      if (this.operationBilanId) {
        url = '/operationBilan/' + this.operationBilanId
      }

      api({
        method: 'POST',
        url: url,
        data: data
      })
        .then(async (response) => {
          await this.generateMonthlyCharges()
          this.$router.push({
            name: 'OperationShow',
            params: {
              operationId: this.operationId,
              currentSection: 1
            }
          })
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: "OperationShow",
              params: {
                operationId: this.operationId,
                message: error.response.data.message
              }
            })
          } else if (error.response.status === 403) {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]['state'] = false
            this.form[invalidField]['invalidFeedback'] = this.$i18n.t(error.response.data.message)
          }
        })
    },

    async generateMonthlyCharges() {

      let data = new FormData()
      data.append('operationId', this.operationId)

      api({
        method: 'POST',
        url: '/treasury/generateMonthlyCharges',
        data: data
      })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationShow',
              params: {
                operationId: this.operationId,
                currentSection: 2,
                message: error.response.data.message
              }
            })
          }
        })
    },

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/operationBilan/bilanEditSteps/OperationBilanChargeFonciereEdit.vue